"use client";
import { useEffect } from "react";
import { useNavbarStore } from "@/stores/navbar-store";

interface Props {
  children?: React.ReactNode;
}

const Layout = ({ children }: Props) => {
  const setVariant = useNavbarStore((state) => state.setVariant);

  useEffect(() => {
    setVariant("float");

    // cleanup
    return () => setVariant("default");
  }, [setVariant]);

  return <>{children}</>;
};

export default Layout;
